<template>
  <template v-if="isApplicant == null" />
  <template v-else>{{ display }}</template>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { displaySenderOrRecipientName } from '@/services/messageAddress'

/**
 * メッセージ送受信先表示コンポーネント
 */
export default defineComponent({
  name: 'MessageSenderOrRecipientName',
  props: {
    // 協議先フラグ
    isApplicant: {
      type: Boolean,
      required: false,
      default: null,
    },
    // 保守区名
    departmentName: {
      type: String,
      required: false,
      default: null,
    },
    // 箇所名
    sectionName: {
      type: String,
      required: false,
      default: null,
    },
    // 社員名
    userName: {
      type: String,
      required: false,
      default: null,
    },
    // 申請者確認用
    isApplicantHistory: {
      type: Boolean,
      required: false,
      default: null,
    },
    // 申請者確認用社員名
    departmentMailName: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const display = computed(() => {
      const { isApplicant, departmentName, userName, isApplicantHistory, departmentMailName } = props
      const arg = isApplicantHistory
        ? { isApplicant, isApplicantHistory, departmentMailName }
        : { isApplicant, departmentName, userName }
      return displaySenderOrRecipientName(arg)
    })

    return {
      display,
    }
  },
})
</script>
